
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoToolsDrawComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
         <div class="card-body text-secondary p-3">
            <layer-info-tools-template></layer-info-tools-template>
            <hr>
<!--            <layer-info-filter-settings-geometry></layer-info-filter-settings-geometry>-->
            <hr>
            <div>
                <span class="fa fa-font"></span> Tekst toevoegen <span class="fa fa-plus float-right"></span>
            </div>
            <hr>
            <button class="btn btn-secondary btn-block">Tekening opslaan als tijdelijke laag</button>
            <button class="btn btn-outline-secondary btn-block">Verwijder alle tekeningen</button>
        </div>
        `;

        initWebComponent(this, template)
    }
}

